<template>
  <span class="badge padding-left-xxs padding-right-xxs grid-x align-middle menu-link-sm"
    >{{ label }}
    <button :aria-label="`show tooltip for ${label} badge`" class="padding-left-xxs" @click="toggleTooltip">
      <span class="tool-tip-dark-small"></span>
    </button>
  </span>
  <ToggleTip ref="tooltipRef" position="right" :width="210">
    <p>{{ tooltipBody }}</p>
  </ToggleTip>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ToggleTip from '@atomic-ui/toggletip/Toggletip';

defineProps<{
  label: string;
  tooltipBody: string;
}>();

const tooltipRef = ref<InstanceType<typeof ToggleTip> | null>(null);

const toggleTooltip = (e: MouseEvent) => {
  if (tooltipRef.value?.toggle) {
    const { currentTarget } = e;
    tooltipRef.value.toggle({ currentTarget });
  }
};
</script>
<style lang="scss" scoped>
@import '~settingSCSS';
@import '~@csgIcons/new/tool-tip-dark-small';

.badge {
  background-color: $hover-color;
  position: relative;
}
</style>
